import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { RouterProvider } from 'react-router';
import { SessionRestore } from '../features/auth/session-restore';
import { createQueryClient } from './query-client';
import { router } from './router';

export function App() {
  const [queryClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <SessionRestore>
        <RouterProvider router={router} />
      </SessionRestore>
    </QueryClientProvider>
  );
}
